import actionCreator from 'helpers/actionCreator'
import { CREATE_FLOOR_PLAN, ADD_FLOOR_PLAN, REMOVE_FLOOR_PLAN, UPDATE_FLOOR_PLAN, DESTROY_FLOOR_PLAN,
  SCALE_FLOOR_PLAN, CANCEL_SCALE_FLOOR_PLAN } from 'actions/floorPlanActionTypes'

/** Called as an action when starting the create Floor Plan saga */
export const createFloorPlanAction = actionCreator(CREATE_FLOOR_PLAN, 'imageSrc', 'imageSize')

/** Called as an action when adding a Floor Plan */
export const addFloorPlanAction = actionCreator(ADD_FLOOR_PLAN, 'id', 'imageSrc', 'imageSize', 'location')

/** Called as an action when updating a Floor Plan */
export const updateFloorPlanAction = actionCreator(UPDATE_FLOOR_PLAN, 'id', 'values')

/** Called as an action when removing a floor Plan */
export const destroyFloorPlanAction = actionCreator(DESTROY_FLOOR_PLAN, 'id')

/** Called as an action when removing a floor Plan */
export const removeFloorPlanAction = actionCreator(REMOVE_FLOOR_PLAN, 'id')

/** Called as an action when starting to scale a floor Plan */
export const scaleFloorPlanAction = actionCreator(SCALE_FLOOR_PLAN, 'id')

/** Called as an action when cancelling scaling a floor Plan */
export const cancelScaleFloorPlanAction = actionCreator(CANCEL_SCALE_FLOOR_PLAN)



// WEBPACK FOOTER //
// ./src/actions/floorPlanActions.js